<template>
  <div class="indexPageBox">
    <div class="bannerBox1">
      <HeaderCom></HeaderCom>
      <div style="height: 520px">
        <div class="banner_item" style="background-image: url('static/image/vl_banner.png');">
          <div class="banner_item1_content">
            <p>视频联动应急处理系统</p>
            <p class="txt1">
              系统宗旨是让全民参与到消防工作中去，最终”把隐患消灭在
              萌芽中”.
            </p>
            <div class="item1_infoBox sr_btn">
              立即申请
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part1Box">
      <div class="part1_content">
        <div class="part1_header">
          <span>方案背景</span>
          <span>一键报警，把隐患消灭在萌芽中</span>
        </div>
        <div class="part1_section">
          党中央、国务院高度重视包括消防在内的公共安全工作。习近平总书记指出：“要把公共安全教育纳入国民教育和精神文明建设体系，加强安全公益宣传””动员全社会的力量来维护公共安全”。当前，老百姓对生存环境的安全需求也越来越强烈，参与监督隐患整改热情日益高涨，如何充分利用社会力量彻底排查治理火灾隐患，确保高温期间火灾形势稳定已成为消防安全工作的重大突破点。
        </div>
        <div class="part1_header">
          <span>方案简介</span>
          <span>一键报警，把隐患消灭在萌芽中</span>
        </div>
        <div class="part1_section">
          是一款通过智能手机，汇集全民力量发现隐患、上报隐患，并自动推送隐患给责任人，责成责任单位限期整改及监督整改情况，帮助政府第一时间解决隐患的工作系统。系统宗旨是让全民参与到消防工作中去，最终”把隐患消灭在萌芽中”.
        </div>
      </div>
    </div>
    <div class="part2Box" style="background-image: url('static/image/vl_scene.png');">
      <div class="part2_content">
        <div class="part2_header">
          <span class="part2_header_txt1">应用场景</span>
          <span class="part2_header_txt2">一键报警，把隐患消灭在萌芽中容</span>
        </div>
      </div>
    </div>
    <div class="part4Box">
      <div class="part4_content">
        <div class="part4_header">
          <span class="part2_header_txt1">解决方案</span>
          <span class="part4_header_txt1">一键报警，把隐患消灭在萌芽中</span>
        </div>
        <div class="part3_tab_contentTxt1">
          <span>主要功能</span>
        </div>
        <div class="part3_space">
          <img src="static/image/vl_function.png" alt="">
        </div>
      </div>
    </div>
    <div class="part4Box">
      <div class="part4_content">
        <div class="part4_content3">
          <div class="part4_header">
            <span class="part2_header_txt1">移动端截图</span>
            <span class="part4_header_txt1">一键报警，把隐患消灭在萌芽中</span>
          </div>
          <div>
            <img src="static/image/vl_screenshot.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="part5Box">
      <div class="part5_content">
        <div class="part5_header">
          <p class="part5_txt1">系统优势</p>
          <p class="part5_txt2">切实落实单位安全生产主体责任</p>
        </div>
        <div class="part5_section">
          <div class="part5_item">
            <div>
              <img src="static/image/vl_operation.png" alt="">
            </div>
            <p class="part5_item_txt1">无需安装软件，易操作</p>
            <p class="part5_item_txt2">一键群众通过微信扫一扫即可进行隐患的拍照上传，还可时刻跟踪整治情况，大家的参与感倍增强了，有利于火灾宣传教育</p>
          </div>
          <div class="part5_item">
            <div>
              <img src="static/image/vl_Safety.png" alt="">
            </div>
            <p class="part5_item_txt1">让人人都成为安全员</p>
            <p class="part5_item_txt2">将群众都纳入到安全检查队列中来，让大家一起来监管，大幅度降低火灾的发生率</p>
          </div>
          <div class="part5_item">
            <div>
              <img src="static/image/vl_police.png" alt="">
            </div>
            <p class="part5_item_txt1">系统自动报警</p>
            <p class="part5_item_txt2">应黄处理过程闭环，逾期不核实或部整改的系统自动报警，并上报大数据系统预警</p>
          </div>
        </div>
      </div>
    </div>
    <RegisterCom></RegisterCom>
    <FooterCom></FooterCom>
  </div>
</template>

<script>
  import HeaderCom from "../common/headerCom"
  import FooterCom from "../common/footerCom"
  import RegisterCom from "../common/registerCom"
  export default {
    name: "videoLinkage",
    components: {HeaderCom, FooterCom,RegisterCom},
    data(){
      return{

      }
    },
    methods: {

    }
  }
</script>

<style scoped>
  @import  '../../assets/css/bannerCom.css';
  .part1Box{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
  }
  .sr_btn{
    background:rgba(60,13,146,1);
  }
  .part1_content{
    width: 1200px;
    box-sizing: border-box;
    padding: 60px 0 0 0;
  }
  .part1_header{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .part1_header>span:nth-of-type(1){
    font-size:28px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
  }
  .part1_header>span:nth-of-type(2){
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(143,149,169,1);
    box-sizing: border-box;
    padding: 30px 0 80px 0;
  }
  .part1_section{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    padding: 0 0 80px 0;
  }
  .part2Box{
    width:100%;
    height: 540px;
    display: flex;
    justify-content: center;
  }
  .part2_content{
    width: 1200px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .part2_header{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    padding: 65px 0 0 0;
    flex-direction: column;
    align-items: center;
  }
  .part4_header{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  .part2_header_txt1{
    font-size:28px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
  }
  .part2_header_txt2{
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(143,149,169,1);
    box-sizing: border-box;
    padding: 20px 0 55px 0;
  }
  .part4Box{
    width: 100%;
    display: flex;
    justify-content: center;
    background: #ffffff;
    box-sizing: border-box;
    padding: 60px 0;
  }
  .part3_tab_contentTxt1{
    width: 100%;
    box-sizing: border-box;
    padding:0 0 45px 0;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(42,99,255,1);
    line-height:30px;
  }
  .part3_space{
    text-align: center;
  }
  .part4_content3{
    width: 1200px;
    box-sizing: border-box;
    padding: 0 100px;
  }
  .part4_content{
    width: 1200px;
    box-sizing: border-box;
  }
  .part4_header_txt1{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(143,149,169,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 25px 0;
  }
  .part5Box{
    width: 100%;
    height: 500px;
    box-sizing: border-box;
    background:rgba(238,242,254,1);
    display: flex;
    justify-content: center;
  }
  .part5_content{
    width: 1200px;
    box-sizing: border-box;
    padding: 60px 100px;
  }
  .part5_txt1{
    font-size:28px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
    line-height:30px;
    text-align: center;
    box-sizing: border-box;
  }
  .part5_txt2{
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:#8F95A9;
    line-height:30px;
    text-align: center;
    padding: 30px;
  }
  .part5_section{
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .part5_item{
    width: 270px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .part5_item_txt1{
    font-size:20px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 30px 0;
  }
  .part5_item_txt2{
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(143,149,169,1);
    line-height:25px;
    text-align: center;
  }
</style>




// WEBPACK FOOTER //
// src/components/info/videoLinkage.vue